import { fromJS } from 'immutable'
import {
  LOB_EDIT_REQUEST,
  LOB_EDIT_SUCCESS,
  LOB_EDIT_FAILURE,
  LOB_EDIT_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case LOB_EDIT_REQUEST:
      return state
        .set('isFetching', true)
    case LOB_EDIT_SUCCESS:
      return state
        .set('lobEdit', fromJS(action.payload.updatedLOB))
        .set('status', 200)
        .set('message', 'Edited Successfully.')
        .set('isFetching', false)
    case LOB_EDIT_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('lobEdit', fromJS(action.payload.message))
        .set('status', fromJS(action.payload.response.statusCode))
        .set('message', fromJS(action.payload.response.message))
        .set('isFetching', false)
    case LOB_EDIT_RESET:
      return state
        .delete('lobEdit')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/lob/lob-edit-reducer.js